module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__content"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content section__copy"
  }, [_c('h2', [_vm._v("Success")]), _vm._v(" "), _c('p', [_vm._v("Thank you for contributing to Britain, Take A Bow.")]), _vm._v(" "), _c('p', [_vm._v("Your clips are now being processed and added to the database, ready to be streamed - this may take a few minutes. Please be aware that because of the random nature of the piece your clips may not always make it into the edit.")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'view-video'
      }
    }
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("Watch a new version")])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-335f2f02","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/upload-success.vue
// module id = 224
// module chunks = 1